<template>
  <div class="cavidade">
    <div class="categorias">Cavidade</div>
    <div>
      <div class="items">
        <table>
          <thead>
            <tr>
              <th>Codigo do Produto</th>
              <th>Descrição do Produto</th>
              <th>Número de Cavidade (Por Produto)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="l in dataMoldeAberto.ListCavidade" :key="l.ID">
              <td>{{ l.COD_PRODUTO }}</td>
              <td>{{ l.DESC_PRODUTO }}</td>
              <td>{{ l.N_CAVIDADE }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>Número Total de Cavidades do Molde</th>
              <th></th>
              <th>{{ setCont(dataMoldeAberto.ListCavidade) }}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div>
      <div class="items-row bd-top">
        <div class="item-title-primary">Tipo de Injeção</div>
        <div class="items-tp-injection">
          <div v-if="dataMoldeAberto.TIPO_DE_INJ_DIR == 'true'">Direta</div>
          <div v-if="dataMoldeAberto.TIPO_DE_INJ_INDIR == 'true'">Indireta</div>
          <!-- <div v-if="dataMoldeAberto.TIPO_DE_INJ_CAM == 'true'">Câmara Quente</div> -->
          <div v-if="dataMoldeAberto.TIPO_DE_INJ_BIC == 'true'">
            Bico Quente
          </div>
        </div>
        <!-- <div class="item-title-primary ">Tipo de Entrada de Injeção</div>
                <div>{{dataMoldeAberto.TIPO_DE_ENT_INJ || "N/A"}}</div> -->
      </div>
    </div>

    <div class="m-inj">
      <div class="sub-categorias bd-bottom bd-top">Maquina Injetora</div>
      <div class="items">
        <div class="items-row bd-right">
          <div class="item-title">Opção I</div>
          <div>{{ dataMoldeAberto.MAQUINA_OP1 || "Não Aplicável" }}</div>
        </div>
        <div class="items-row bd-right">
          <div class="item-title">Opção II</div>
          <div>{{ dataMoldeAberto.MAQUINA_OP2 || "Não Aplicável" }}</div>
        </div>
        <div class="items-row">
          <div class="item-title">Opção III</div>
          <div>{{ dataMoldeAberto.MAQUINA_OP3 || "Não Aplicável" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue-demi";
export default {
  props: {
    dataMoldeAberto: "",
  },
  data() {
    return {
      contador: 0,
    };
  },

  methods: {
    setCont(cavidades) {
      let val = 0;
      cavidades.map((item) => {
        val = val + item.N_CAVIDADE;
      });
      return val;
    },
  },
};
</script>

<style scoped>
/* MAIN - CAVIDADE */

.cavidade table th {
  background: #ededed;
  font-size: 0.7rem;
}

.cavidade table {
  width: 100%;
  text-align: center;
  border: none;
  font-size: 10px;
  border-collapse: collapse;
  border-spacing: 0;
}

.cavidade table th,
td {
  padding: 0.2rem 0;
}
.items-tp-injection {
  width: 100%;
  display: flex !important;
  flex-direction: row;
}

.item-title-primary {
  background: #ededed;
}
</style>

